import React from "react";
import Card from "../../components/page/Card";
import CommonInput from "../../components/forms/CommonInput";
import CommonInputDate from "../../components/forms/CommonInputDate";
import {
  handleChange,
  handleChangeUnmask,
} from "../../helpers/handleFormChanges";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import CommonButton from "../../components/buttons/CommonButton";
import CommonInputMask from "../../components/forms/CommonInputMask";
import CommonSelect from "../../components/forms/CommonSelect";

function GerarRecalculo() {
  const [values, setValues] = React.useState({});

  const gerarRecalculo = async () => {
    const formData = new FormData();
    formData.append("documento", values?.documento);
    formData.append("cpf_cnpj", values?.cpf_cnpj);
    formData.append("mes_referencia", values?.mes_referencia);
    formData.append("data_vencimento", values?.data_vencimento);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    // const response = await gerarRecalculoApi.request(formData);
    const response = "galo";
    if (!response) return;
    CommonSwal({
      title: "Recáclculo gerado com sucesso!",
      icon: "success",
    });
  };

  return (
    <>
      <Card>
        <div className="row">
          <div className="col-md-3 mb-3">
            <CommonInputMask
              label="CNPJ"
              id="cpf_cnpj"
              value={values.cpf_cnpj}
              onChange={(e) => handleChangeUnmask(e, values, setValues)}
              mask="99.999.999/9999-99"
              required
            />
          </div>
          <div className="col-md-3 mb-3">
            <CommonSelect
              label="Tipo de documento"
              id="documento"
              value={values.documento}
              onChange={(e) => handleChange(e, values, setValues)}
              data={Object.keys(documentosRecalculo).map((id) => ({
                text: documentosRecalculo[id],
                id,
              }))}
              placeholder="Selecione o tipo"
            />
          </div>
          <div className="col-md-3 mb-3">
            <CommonInput
              label="Mês de referência"
              id="mes_referencia"
              value={values.mes_referencia}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              type="month"
              required
            />
          </div>
          <div className="col-md-3 mb-3">
            <CommonInputDate
              label="Nova data de vencimento"
              id="data_vencimento"
              value={values.data_vencimento}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col text-end">
            <CommonButton onClick={gerarRecalculo} color={"success"}>
              Gerar
            </CommonButton>
          </div>
        </div>
      </Card>
    </>
  );
}

const documentosRecalculo = {
  1: "INSS-IRRF",
  2: "DAS Simples Nacional",
  3: "DASMEI",
};

export default GerarRecalculo;
